import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id B743ECCA-F8DA-4F54-BF8F-8558F370AECB
 * name arrow-u-up-right
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-u-up-right.svg
 * tags
 */
export const ArrowUUpRightIcon = createSvgIcon(<><path d="M21.5 9.5L20.09 10.92L17 7.83V13.5C17 17.09 14.09 20 10.5 20S4 17.09 4 13.5V6H6V13.5C6 16 8 18 10.5 18S15 16 15 13.5V7.83L11.91 10.91L10.5 9.5L16 4L21.5 9.5Z" /></>, 'ArrowUUpRightIcon');
export default ArrowUUpRightIcon